import getYear from "date-fns/getYear";
import getMonth from "date-fns/getMonth";
import "./RenderCustomheader.css"


const range = (start, end) => {
      return new Array(end - start).fill().map((d, i) => i + start);
};
const years = range(1950, getYear(new Date()) + 10, 1);

const thaiMonths = [
      "มกราคม",
      "กุมภาพันธ์",
      "มีนาคม",
      "เมษายน",
      "พฤษภาคม",
      "มิถุนายน",
      "กรกฎาคม",
      "สิงหาคม",
      "กันยายน",
      "ตุลาคม",
      "พฤศจิกายน",
      "ธันวาคม"
  ];
export const RenderCustomHeader = ({date,changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled, }) => {
      
      return (
          <div className="react-datepicker__custom-header">
              <div className="react-datepicker__custom-header-left">
                  <button
                      type="button"
                      className="react-datepicker__navigation react-datepicker__navigation--previous"
                      aria-label="previous month"
                      onClick={decreaseMonth}
                      disabled={prevMonthButtonDisabled}
                  >
                      <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous" />
                  </button>
              </div>
              <div className="react-datepicker__custom-header-center">
                  <div>

                      <select
                          value={thaiMonths[getMonth(date)]}
                          onChange={({ target: { value } }) =>
                              changeMonth(thaiMonths.indexOf(value))
                          }
                      >
                          {thaiMonths.map(option => (
                              <option key={option} value={option}>
                                  {option}
                              </option>
                          ))}
                      </select>

                      <select
                          value={getYear(date)}
                          onChange={({ target: { value } }) => changeYear(value)}
                      >
                          {years.map(option => (
                              <option key={option} value={option}>
                                  {Number(option) + 543}
                              </option>
                          ))}
                      </select>


                  </div>
              </div>
              <div className="react-datepicker__custom-header-right">
                  <button
                      type="button"
                      className="react-datepicker__navigation react-datepicker__navigation--next"
                      aria-label="next month"
                      onClick={increaseMonth}
                      disabled={nextMonthButtonDisabled}
                  >
                      <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next" />
                  </button>
              </div>
          </div>
      );
  };